(() => {
  if (!customElements.get('varia-dial')) customElements.define('varia-dial', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.profiles = JSON.parse(this.querySelector('[data-burr-profiles]').textContent);
      this.sensory = JSON.parse(this.querySelector('[data-sensory-text]').textContent);
      this.coach = JSON.parse(this.querySelector('[data-coaching-text]').textContent);
      this.burrOptions();
      this.text = JSON.parse(this.querySelector('[data-guidance-text]').textContent);
      this.result = this.querySelector('[data-result]');
      this.status = this.querySelector('[data-status]');
      this.key = 'varia-brew-v1';
      const model = new URLSearchParams(location.search).get('model');
      if ([...this.form.elements.model.options].some(o => o.value === model)) this.form.elements.model.value = model;
      this.form.addEventListener('submit', e => { e.preventDefault(); this.calculate(); });
      this.form.addEventListener('input', () => { this.result.hidden = true; this.status.textContent = ''; });
      this.form.elements.model.addEventListener('change',()=>{this.burrOptions();this.form.elements.scale_known.checked=false;this.form.elements.setting.value='';this.result.hidden=true;});
      this.form.elements.experience.addEventListener('change',()=>{const d=this.form.elements,r=d.experience.value==='rich',c=d.experience.value==='clear';d.mouthfeel.value=r?'full':c?'light':'medium';d.separation.value=r?'blended':c?'distinct':'balanced';d.acidity.value=r?'gentle':c?'bright':'any';});
      this.form.elements.method.addEventListener('change', () => this.method());
      this.form.elements.burr.addEventListener('change',()=>{this.form.elements.scale_known.checked=false;this.result.hidden=true;});
      this.addEventListener('click', async e => {
        const button = e.target.closest('button');
        if (!button) return;
        if(button.hasAttribute('data-apply-next')&&this.nextRecipe){
          this.form.elements.dose.value=this.nextRecipe.dose;this.form.elements.yield.value=this.nextRecipe.yield;
          if(this.nextRecipe.setting!==null)this.form.elements.setting.value=this.nextRecipe.setting;
          this.form.elements.time.value='';this.form.elements.first_drop.value='';this.form.elements.taste.value='untasted';
          this.form.elements.puck.value='unknown';this.form.elements.flow.value='unknown';
          for(const key of ['observed_sweetness','observed_acidity','observed_mouthfeel','enjoyment'])this.form.elements[key].value='unsure';this.form.elements.observed_aroma.value='';this.form.elements.observed_finish.value='';
          this.result.hidden=true;this.status.textContent=this.coach.applied;this.form.elements.time.focus();
        }
        if (button.hasAttribute('data-flo')) {
          Object.entries({method:'filter',dose:'13',yield:'200',time:'140',flow:'steady',taste:'balanced'}).forEach(([k,v]) => this.form.elements[k].value = v);
          this.method(); this.querySelector('[data-baseline]').textContent = this.text.flo_recipe;
          this.result.hidden = true; this.status.textContent = this.text.flo_recipe;
        }
        if (button.hasAttribute('data-save')) {
          try { localStorage.setItem(this.key, JSON.stringify(Object.fromEntries(new FormData(this.form)))); this.status.textContent = this.text.saved; }
          catch { this.status.textContent = this.text.storage_error; }
        }
        if (button.hasAttribute('data-load')) {
          try {
            const saved = JSON.parse(localStorage.getItem(this.key));
            if (!saved || typeof saved !== 'object') { this.status.textContent = this.text.nothing_saved; return; }
            if (['vs3','vs4','vs6','evo','other'].includes(saved.model))this.form.elements.model.value=saved.model;
            this.burrOptions();this.form.elements.scale_known.checked=false;
            for (const [k,v] of Object.entries(saved)) {
              const input = this.form.elements[k];
              if(input?.type==='checkbox'){input.checked=v==='on';continue;}
              if (!input || typeof v !== 'string' || v.length > 120) continue;
              if (input.tagName === 'SELECT' && ![...input.options].some(o=>o.value===v)) continue;
              input.value = v;
            }
            this.method(); this.calculate(false); this.status.textContent = this.text.loaded;
          } catch { this.status.textContent = this.text.storage_error; }
        }
        if (button.hasAttribute('data-forget')) {
          try { localStorage.removeItem(this.key); this.status.textContent = this.text.forgotten; }
          catch { this.status.textContent = this.text.storage_error; }
        }
        if (button.hasAttribute('data-copy')) {
          try { await navigator.clipboard.writeText(this.querySelector('[data-summary]').value); this.status.textContent = this.text.copied; }
          catch { this.querySelector('[data-summary]').select(); this.status.textContent = this.text.copy_error; }
        }
        if (button.hasAttribute('data-chat')) {
          try { if (typeof window.zE !== 'function') throw new Error(); window.zE('messenger','open'); this.status.textContent = this.text.chat_open; }
          catch { this.status.textContent = this.text.chat_error; }
        }
      });
      this.burrOptions();
      const params=new URLSearchParams(location.search);
      for(const k of ['burr','experience','mouthfeel','separation','acidity','sweetness','finish','flavour','roast']){const el=this.form.elements[k],v=params.get(k);if([...el.options].some(o=>o.value===v))el.value=v;}
      const method = params.get('method');
      if (['espresso','filter'].includes(method)) this.form.elements.method.value = method;
      this.method();
    }
    burrOptions() {
      const select=this.form.elements.burr,current=select.value;select.replaceChildren(new Option(this.sensory.stock,''));
      for(const p of this.profiles.filter(p=>p.model===this.form.elements.model.value))select.append(new Option(p.name,p.id));
      if([...select.options].some(o=>o.value===current))select.value=current;
    }
    method() {
      const filter = this.form.elements.method.value === 'filter';
      const basket = this.form.elements.basket;
      basket.disabled = filter; basket.parentElement.hidden = filter;
      this.querySelectorAll('[data-espresso-field]').forEach(label=>{label.hidden=filter;label.querySelector('input,select').disabled=filter;});
      this.result.hidden=true;
      this.querySelector('[data-baseline]').textContent = this.text[filter ? 'filter_start' : 'espresso_start'];
    }
    words(key,values={}) {
      return (this.coach[key]||'').replace(/\{(\w+)\}/g,(_,k)=>values[k]??'');
    }
    shotPlan(d,branch) {
      const dose=Number(d.dose),out=Number(d.yield),esp=d.method==='espresso',n=x=>Number(x.toFixed(1)).toString();
      let nextDose=dose,nextYield=out,nextSetting=null,action='',follow=this.words('follow_yield');
      const lo=d.basket_min?Number(d.basket_min):null,hi=d.basket_max?Number(d.basket_max):null;
      const adjust=direction=>{
        let text=this.words('grind_'+direction),setting=String(d.setting||'').trim();
        if(d.model==='vs3'&&this.form.elements.scale_known.checked&&/^\d+(\.\d{1,2})?$/.test(setting)){
          const current=Number(setting),next=Math.round((current+(direction==='finer'?-.1:.1))*100)/100;
          if(current>=.2&&current<=9.8&&next>=.1&&next<=9.9){nextSetting=n(next);text=this.words('grind_exact',{direction:this.words(direction),current:setting,next:nextSetting});}
          else text+=' '+this.words('grind_boundary');
        }else if(d.model==='other')text+=' '+this.words('grind_other');
        return text;
      };
      if(branch==='dose'){
        if(lo!==null&&dose<lo)nextDose=lo;
        else if(hi!==null&&dose>hi)nextDose=hi;
        else if(d.headspace==='contact'&&lo!==null&&dose-.5>=lo)nextDose=dose-.5;
        else if(d.headspace==='large'&&d.puck==='soupy'&&hi!==null&&lo!==null&&dose+.5<=hi&&dose+.5>=lo)nextDose=dose+.5;
        if(nextDose!==dose){nextYield=Number((nextDose*(out>0?out/dose:2)).toFixed(1));action=this.words('dose_action',{dose:n(nextDose),yield:n(nextYield)});}
        else action=this.words('dose_check');
        follow=this.words('follow_dose');
      }else if(branch==='uneven')action=this.words('action_prep');
      else if(branch==='pressurised')action=this.words('action_pressurised');
      else if(branch==='choked'){nextDose=Math.min(hi??dose,Math.max(lo??dose,dose));action=this.words('action_choked')+' '+adjust('coarser');nextYield=Number((nextDose*2).toFixed(1));follow=this.words('follow_grind');}
      else if(['fast','slow'].includes(branch)||( !esp&&['sour','bitter'].includes(branch))){
        action=adjust(['fast','sour'].includes(branch)?'finer':'coarser')+' '+this.words(esp?'grind_hold':'filter_hold',{dose:n(dose),yield:n(out)});follow=this.words('follow_grind');
      }else if(branch==='strong')action=this.words(esp?'dilute_action':'filter_strong');
      else if(['sour','bitter','weak'].includes(branch)){
        const delta=esp?2:10;
        nextYield=Number(Math.max(1,out+(branch==='sour'?delta:-delta)).toFixed(1));
        action=this.words(esp?'yield_action':'filter_water',{dose:n(dose),old:n(out),yield:n(nextYield)});
      }else action=this.words('hold_action');
      let cause=this.words('cause_'+branch);
      if(!esp&&['fast','slow'].includes(branch))cause=this.words('filter_cause_'+branch);
      const drop=d.first_drop!==undefined&&d.first_drop!==''?Number(d.first_drop):null;
      const pump=d.timer_origin==='drip'?(drop!==null?Number(d.time)+drop:null):Number(d.time);
      let targets=this.words('next_recipe',{dose:n(nextDose),kind:this.words(esp?'beverage':'brew_water'),yield:n(nextYield),ratio:(nextYield/nextDose).toFixed(2)});
      if(esp){
        targets+=' '+this.words(d.preinfusion==='standard'&&d.basket!=='pressurised'?'standard_targets':'custom_targets');
        targets+=' '+(pump!==null?this.words('time_observed',{time:n(pump),drop:drop!==null?n(drop)+' s':this.words('not_recorded')}):this.words('time_missing'));
      }else targets+=' '+this.words('filter_targets');
      if(!esp&&['fast','slow','sour','bitter'].includes(branch))follow=this.words('follow_filter');
      const puck=this.words(esp?(d.headspace==='contact'?'puck_contact':'puck_read'):'filter_puck');
      const container=this.querySelector('[data-shot-plan]');container.replaceChildren();container.className='vg-shot-plan';
      const parts=[['why_title',cause],['action_title',action],['target_title2',targets],['puck_title',puck],['follow_title',follow]];
      for(const [key,body] of parts){const section=document.createElement('article'),h=document.createElement('h3'),p=document.createElement('p');h.textContent=this.words(key);p.textContent=body;section.append(h,p);container.append(section);}
      this.nextRecipe={dose:n(nextDose),yield:n(nextYield),setting:nextSetting};
      this.querySelector('[data-apply-next]').hidden=['pressurised','untasted'].includes(branch)||(branch==='dose'&&nextDose===dose);
      return parts.map(([key,body])=>this.words(key)+': '+body).join('\n');
    }
    calculate(focus = true) {
      this.result.hidden=true;
      if (!this.form.reportValidity()) return;
      const d = Object.fromEntries(new FormData(this.form));
      const dose = Number(d.dose), output = Number(d.yield), time = Number(d.time);
      if (![dose,output,time].every(Number.isFinite) || dose <= 0 || output < 0 || time <= 0) { this.status.textContent=this.text.invalid; return; }
      const first=d.first_drop!==undefined&&d.first_drop!==''?Number(d.first_drop):null;
      if((d.basket_min&&d.basket_max&&Number(d.basket_min)>Number(d.basket_max))||(d.method==='espresso'&&d.timer_origin==='pump'&&first!==null&&first>time)){
        this.result.hidden=true;this.status.textContent=this.coach.check_measurements;return;
      }
      if(d.method==='filter'&&output===0){this.result.hidden=true;this.status.textContent=this.text.invalid;return;}
      let branch = d.taste;
      if(d.method==='espresso'&&output===0)branch='choked';
      else if(d.method==='espresso'&&((d.basket_min&&dose<Number(d.basket_min))||(d.basket_max&&dose>Number(d.basket_max))||d.headspace==='contact'))branch='dose';
      else if (d.method === 'espresso' && d.basket === 'pressurised') branch = 'pressurised';
      else if (d.flow === 'uneven') branch = 'uneven';
      else if(d.method==='espresso'&&((d.basket_min&&dose<Number(d.basket_min))||(d.basket_max&&dose>Number(d.basket_max))||d.headspace==='contact'||(d.headspace==='large'&&d.puck==='soupy'&&d.taste!=='balanced')))branch='dose';
      else if (!['balanced','untasted'].includes(d.taste) && ['fast','slow'].includes(d.flow)) branch = d.flow;
      const advice = this.text[branch+'_'+d.method] || this.text[branch+'_advice'] || this.coach['cause_'+branch];
      const title = this.text[branch+'_title'] || this.coach.action_title;
      this.querySelector('[data-result-title]').textContent = title;
      this.querySelector('[data-advice]').textContent = '';
      const plan=this.shotPlan(d,branch);
      const ratio = this.text.ratio_label+': 1:'+ (output/dose).toFixed(2)+' · '+this.text[d.method+'_ratio'];
      this.querySelector('[data-ratio]').textContent = ratio;
      const lines = [...this.form.elements].filter(el => el.name && !el.disabled).map(el => {
        const label = el.parentElement.firstChild.textContent.trim();
        const value = el.tagName === 'SELECT' ? el.selectedOptions[0].textContent : el.value;
        return label+': '+value;
      });
      this.querySelector('[data-summary]').value = [...lines,ratio,title,plan].join('\n');
      this.result.hidden = false;
      if (focus) this.result.focus();
    }
  });
  if (!customElements.get('varia-owner')) customElements.define('varia-owner', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready=true;
      const select=this.querySelector('select');
      const model=new URLSearchParams(location.search).get('model');
      if ([...select.options].some(o=>o.value===model)) select.value=model;
      const update=()=>this.querySelectorAll('[data-owner-model]').forEach(card=>card.hidden=card.dataset.ownerModel!==select.value);
      select.addEventListener('change',update); update();
    }
  });
})();
